module.exports = __webpack_public_path__ + "img/chat_bubble.0e1aafb4.svg";